<template>
  <div class="container">
    <h1 class="title">Logged out</h1>
    <h4 class="subtitle mt-2">You are logged out from account.
      <a @click="$router.push({'name': 'Login'})">Log in</a> again?</h4>
  </div>
</template>

<script>
import axios from "axios";

import {mapMutations} from "vuex";

export default {
  name: "Logout",
  methods: {
    ...mapMutations('auth', ['setAdmin']),
    logout() {
      axios.get('/api/auth/logout')
        .then(response => {
          this.setAdmin(null)
          console.log(response)
        })
        .catch(error => console.log(error))
    }
  },
  created() {
    this.logout()
  }
}
</script>

<style scoped>

</style>
